module.exports = __webpack_public_path__ + "img/mauritius.ac4eb8df.svg";